<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
                <b-col xl="6" lg="6" sm="12">
                  <b-row>
                      <b-col xl="5" lg="5" sm="12">
                          <label label-cols-sm="4"><strong>{{ $t('retailerManagement.quotation_id') }}</strong></label>
                      </b-col>
                      <b-col xl="7" lg="7" sm="12">
                          <label label-cols-sm="4" v-if="demandType === 1">{{ 'P - ' }} {{ dataArray.quotation_id }}</label>
                          <label label-cols-sm="4" v-else>{{ 'W - ' }} {{ dataArray.quotation_id }}</label>
                      </b-col>
                  </b-row>
                </b-col>
                <b-col xl="6" lg="6" sm="12">
                  <b-row>
                      <b-col xl="5" lg="5" sm="12">
                          <label label-cols-sm="4"><strong>{{ $t('retailerManagement.quotation_date') }}</strong></label>
                      </b-col>
                      <b-col xl="7" lg="7" sm="12">
                          <label label-cols-sm="4">{{ dataArray.quotation_date | dateFormat }}</label>
                      </b-col>
                  </b-row>
                </b-col>
            </b-row>
              <hr>
            <b-row>
              <b-col lg="12" sm="12" class="form-for-textarea">
                  <b-overlay :show="unitLoad">
                    <b-table-simple striped bordered small>
                        <b-tr style="background-color: #66CC99; color: white">
                            <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                            <b-th>{{ $t('production_store.pro_category') }}</b-th>
                            <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                            <b-th>{{ $t('retailerManagement.product_quantity') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                            <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in dataArray.quotation_details" :key="index">
                            <b-td>{{ $n(index + 1) }}</b-td>
                            <b-td>{{ getCategoryName(item.product_id) }}</b-td>
                            <b-td>{{ productNameById(item.product_id) }}</b-td>
                            <b-td>{{ unitNameById(item.unit_id) }}</b-td>
                            <b-td>{{ $n(item.quantity) }}</b-td>
                            <b-td>{{ $n(item.unit_price) }}</b-td>
                            <b-td>{{ $n(item.total_price) }}</b-td>
                        </b-tr>
                        <b-td colspan="6">
                          <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                        </b-td>
                        <b-td>{{ $n(sumTotal) }}</b-td>
                    </b-table-simple>
                  </b-overlay>
                  <div v-if="dataArray.status === 3">
                      <h5 class="mb-3" style="border-bottom: 1px solid #ddd"> {{ $t('production_store.forward') + ' ' + $t('production_store.details') }}</h5>
                      <b-row v-for="(item, index) in dataArray.quotation_forwards" :key="index">
                          <b-col>
                              <b-overlay :show="unitLoad">
                                  <b-table-simple striped bordered small>
                                      <tr class="bg-light">
                                          <th>{{ $t('production_store.comment') }}</th>
                                          <th>{{ $t('production_store.commented_by') }}</th>
                                          <th>{{ $t('production_store.designation') }}</th>
                                      </tr>
                                      <tr>
                                          <td v-if="currentLocale === 'en'">{{ item.note }}</td>
                                          <td v-else>{{ item.note_bn }}</td>
                                          <td>{{ getName(item.sender_id) }}</td>
                                          <td>{{ designation }}</td>
                                      </tr>
                                  </b-table-simple>
                              </b-overlay>
                          </b-col>
                          <hr>
                      </b-row>
                  </div>
              </b-col>
              <div class="col text-right">
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.cancel') }}</b-button>
              </div>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
.form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
</style>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '../../../../../config/api_config'
import { quotationDetailsById } from '../../api/routes'

export default {
  props: ['id', 'demandType', 'userList'],
  data () {
    return {
      dataArray: {
        comment: '',
        comment_bn: ''
      },
      unitLoad: false,
      comments: '',
      sum: 0,
      sumTotal: '',
      designation: ''
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
      if (this.id) {
          this.getDemandDetails(this.id)
      }
  },
  mounted () {
    core.index()
  },
  methods: {
    getCategoryName (Id) {
      const product = this.productCommonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.productCommonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    getGrandTotal () {
      let sumM = 0
      this.dataArray.quotation_details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total_price)
      })
      this.sumTotal = parseFloat(sumM)
    },
    async getDemandDetails (id) {
      this.unitLoad = true
      const result = await RestApi.getData(productionServiceBaseUrl, quotationDetailsById + '/' + id)
      if (result.success) {
        this.dataArray = result.data
        this.getGrandTotal()
        if (this.$i18n.locale === 'bn') {
          this.comments = this.dataArray.comment_bn
        } else {
          this.comments = this.dataArray.comment
        }
        this.unitLoad = false
      }
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
      if (this.$i18n.locale === 'bn') {
          return unit.text_bn
      } else {
          return unit.text_en
      }
    },
    getName (id) {
        const idd = parseInt(id)
        const user = this.userList.find(user => user.value === idd)
        this.designation = this.getDesignation(user.designation_id)
        if (this.$i18n.locale === 'bn') {
            return user.text_bn
        } else {
            return user.text_en
        }
    },
    getDesignation (id) {
        const Designation = this.$store.state.commonObj.designationList.find(designation => designation.value === id)
        if (this.$i18n.locale === 'bn') {
            return Designation.text_bn
        } else {
            return Designation.text_en
        }
    }
  }
}
</script>
